import React, { useState } from 'react'
import PropTypes from 'prop-types'
import LoginForm from 'src/components/auth/login-form'
import RegisterForm from 'src/components/auth/register-form'
import ForgotPasswordForm from 'src/components/auth/forgotpassword-form'
import GenericModal from 'src/components/modals/generic-modal'
import { useAuthService } from 'theme/services/auth/auth-service'

export const MODES = {
  REGISTER: 'register',
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgot-password',
}

const LoginModal = ({ openModal, handleClose }) => {
  const authService = useAuthService()
  const [mode, setMode] = useState(MODES.LOGIN)

  const changeMode = (newMode) => {
    if (newMode === MODES.REGISTER || newMode === MODES.LOGIN || newMode === MODES.FORGOT_PASSWORD) {
      setMode(newMode)
    }

    // Prevents closing modal when registration is not fully finished
    authService.setRegistering(newMode === MODES.REGISTER)
  }

  return (
    <GenericModal isVisible={openModal} onClose={handleClose}>
      <div className="flex-1 flex flex-col justify-center pt-12 pb-16 px-4 sm:px-6 lg:flex-none lg:px-20 lg:pt-10">
        {mode === MODES.LOGIN && <LoginForm changeMode={changeMode} />}
        {mode === MODES.REGISTER && <RegisterForm changeMode={changeMode} />}
        {mode === MODES.FORGOT_PASSWORD && <ForgotPasswordForm changeMode={changeMode} />}
      </div>
    </GenericModal>
  )
}

LoginModal.propTypes = {
  openModal: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
}

export default LoginModal
